module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [(_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('navbar'), _vm._v(" "), _c('h1', {
    staticClass: "profile-title details-width"
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_order_details')))]), _vm._v(" "), (_vm.status_title == 'a') ? _c('steps', {
    attrs: {
      "current": 1
    }
  }, [_c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_1')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_2')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_3')
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.status_title == 'b') ? _c('steps', {
    attrs: {
      "current": 2
    }
  }, [_c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_1')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_2')
    }
  }), _vm._v(" "), _c('step', {
    attrs: {
      "title": _vm.$t('order_details_state_3')
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-list"
  }, [_c('h3', {
    staticClass: "listing details-width"
  }, [_vm._v(_vm._s(_vm.$t('Order_Details_Listing')))]), _vm._v(" "), _c('div', {
    staticClass: "order-group"
  }, [_c('div', {
    staticClass: "order-group-header details-width"
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_product')))]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_price')))]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_Quantity')))]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_order_Subtotal')))]), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('user_order_operation')) + " ")])], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "details-width order-number"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('user_center_order_order_num')) + "：" + _vm._s(_vm.orders_info.order_sn))]), _vm._v(" "), (_vm.screenWidth) ? _c('div', {
    staticClass: "order-group-lists"
  }, _vm._l((_vm.orders), function(order) {
    return _c('div', {
      staticClass: "order-group-list"
    }, [_c('div', {
      staticClass: "order-content"
    }, [_c('Row', [_c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('div', {
      staticClass: "order-col"
    }, [_c('img', {
      attrs: {
        "src": order.goods_img,
        "width": "100"
      }
    })])]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('div', {
      staticClass: "order-col"
    }, [_c('h3', [_vm._v(_vm._s(order.goods_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(order.goods_remarks))])])]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('div', {
      staticClass: "order-col"
    }, [_c('p', {
      staticClass: "order-col-title text-primary"
    }, [_vm._v(_vm._s(order.goods_unit) + _vm._s(order.goods_price))])])]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('div', {
      staticClass: "order-col"
    }, [_c('p', {
      staticClass: "order-col-title"
    }, [_vm._v(_vm._s(order.goods_num))])])]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [_c('div', {
      staticClass: "order-col selecte"
    }, [_c('p', {
      staticClass: "order-col-title"
    }, [_vm._v("\n                                        " + _vm._s(order.goods_unit) + _vm._s(parseFloat(order.goods_price) * order.goods_num))])])]), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": "4"
      }
    }, [(_vm.orders_info.status_type == 1) ? _c('div', {
      staticClass: "order-col"
    }, [_c('a', {
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": _vm.cancleOrder
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm.$t('user_center_order_cancel_order')) + "\n                                    ")])]) : (_vm.orders_info.status_type == 2) ? _c('div', {
      staticClass: "order-col"
    }, [(_vm.orders_status == 2) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm.$t('user_order_not_for_deli')) + "\n                                    ")]) : (_vm.orders_status == 3) ? _c('span', [_vm._v("\n                                        " + _vm._s(_vm.$t('user_order_transporting')) + "\n                                    ")]) : (_vm.orders_status == 5) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm.$t('user_order_canceled')) + "\n                                    ")]) : _vm._e()]) : (_vm.orders_info.status_type == 3) ? _c('div', {
      staticClass: "order-col"
    }, [_c('router-link', {
      staticStyle: {
        "font-weight": "normal"
      },
      attrs: {
        "to": {
          name: 'Aftermarket',
          params: {
            order_sn: _vm.orders_info.order_sn
          },
          query: {
            goods_id: order.goods_id,
            after_id: order.if_after
          }
        }
      }
    }, [(order.goods_status == 0) ? _c('a', [_vm._v("\n                                            " + _vm._s(_vm.$t('user_center_order_return_exchange')) + "\n                                        ")]) : (order.goods_status == 1) ? _c('a', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t('user_order_returning')) + "\n                                        ")]) : (order.goods_status == 3) ? _c('a', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t('user_order_return_completed')) + "\n                                        ")]) : (order.goods_status == 9) ? _c('a', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("\n                                           " + _vm._s(_vm.$t('user_order_replacement_cancelled')) + "\n                                        ")]) : _vm._e()])], 1) : _vm._e()])], 1)], 1)])
  })) : _vm._l((_vm.orders), function(order) {
    return _c('div', {
      staticClass: "mobile-order-group-lists"
    }, [_c('div', {
      staticClass: "goods-header"
    }, [_c('img', {
      attrs: {
        "src": order.goods_img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-desc"
    }, [_c('h3', [_vm._v("\n                        " + _vm._s(order.goods_name) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("$" + _vm._s(order.goods_price) + " x " + _vm._s(order.goods_num))]), _vm._v(" "), _c('div', {
      staticClass: "order-col"
    }, [_c('router-link', {
      staticStyle: {
        "font-weight": "normal"
      },
      attrs: {
        "to": {
          name: 'Aftermarket',
          params: {
            order_sn: _vm.orders_info.order_sn
          },
          query: {
            goods_id: order.goods_id,
            after_id: _vm.orders[0].if_after
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t('user_center_order_return_exchange')) + "\n                        ")])], 1)])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "order-payment details-width"
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "payment-left"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Order_Details_Payment_and_logistics')))]), _vm._v(" "), _c('p', {
    staticClass: "pay-method"
  }, [_vm._v(_vm._s(_vm.$t('user_order_payment_method')) + "："), _c('span', [_vm._v(_vm._s(_vm.orders_info.pay_type))])]), _vm._v(" "), _c('p', {
    staticClass: "pay-time"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('Order_Details_Payment_time')) + "："), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(parseFloat(_vm.orders_info.add_time * 1000))))])]), _vm._v(" "), _c('h3', {
    staticClass: "take_away"
  }, [_vm._v(_vm._s(_vm.$t('details_shipping_type')))]), _vm._v(" "), (_vm.take_type == 'b') ? _c('div', {
    staticClass: "take_way"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('details_Pickup')) + ":" + _vm._s(_vm.orders_info.stord_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orders_info.stord_address))])]) : (_vm.take_type == 'a') ? _c('div', {
    staticClass: "take_way"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('details_express')) + ":" + _vm._s(_vm.orders_info.express_company))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('details_Tracking_No')) + ":" + _vm._s(_vm.orders_info.tracking_number))])]) : _vm._e()])]), _vm._v(" "), _c('i-col', {
    staticClass: "order-details",
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 12
    }
  }, [_c('div', {
    staticClass: "payment-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Order_Details_Payment_Freight')) + "："), _c('span', [_vm._v("+ " + _vm._s(_vm.orders_info.unit) + " " + _vm._s(_vm.orders_info.shipping_price))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Order_Details_Payment_Real_Payment')) + ": "), _c('span', {
    staticClass: "real-pay text-primary"
  }, [_vm._v(_vm._s(_vm.orders_info.unit) + " " + _vm._s(_vm.orders_info.need_pay_usd_price))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orders_info.username))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orders_info.mobile))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orders_info.address))])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0feab3c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/MyDetails.vue
// module id = 842
// module chunks = 0